// @flow
import { useContext } from 'react';

import { getLastElementOfArray } from '../common-utils/utils';
import { EstimateContext } from '../contexts/EstimateContext';

// Rate cards are ordered oldest first, so the last actionable one is the latest RC.
export const getLatestActionableRateCardName = (rateCards) => {
  const actionableRateCards = rateCards.filter((rateCard) => rateCard.actionable ?? true);
  return getLastElementOfArray(actionableRateCards).name;
};

export const useEstimateRateCards = () => {
  const estimate = useContext(EstimateContext);
  return estimate.commit_config.rate_cards;
};
